export const colorSelection = (code: string) => {
    switch (code) {
        case 'SSSS Dashboard':
            return 'ssss'
        case 'CDE':
            return 'cde'
        case 'Varadise Twin':
            return 'twin'
        case 'DWSS':
            return 'dwss'
        case 'Project Finance':
            return 'finance'
        case 'BIM 360':
            return 'bim360'
        case 'Chatbot': 
            return 'chatbot'
        case 'GPS':
            return 'gps'
        case 'error':
            return 'error'
        case 'disabled':
            return 'info'
        case 'lightgrey':
            return 'lightgrey'
        default:
            return undefined
    }
}

export const backgroundColorSelection = (code: string) => {
    switch(code){
        case 'SSSS Dashboard':
            return '#D4F0D6'
        case 'CDE':
            return '#F5DEF2'
        case 'Varadise Twin':
            return '#D1DFFF'
        case 'DWSS':
            return '#B9DCE0'
        case 'BIM 360':
            return '#F9D8BE'
        case 'Chatbot':
            return '#F5EFE3'
        default:
            return '#D4F0D6'
    }
}